import { put, select } from "redux-saga/effects";
import importer from "common/importer";

const DonorsActions = importer("Stores/Donors/Actions");
const { tokens } = importer("Stores/Users/Select", null);

export default function* success(res) {
  // console.log(res)
  const _tokens = yield select(tokens);
  const { token_type, id_token } = _tokens;
  const token = `${token_type} ${id_token}`;
  const user = yield select((state) => state.donors.donors.data);
  yield put(DonorsActions.getDonors(user.id));
}
